import React from 'react'

const TextAreaInput = ({placeholder, name, value, onChange, required}) => (
    <div className="form-group">
        <textarea placeholder={placeholder} name={name} value={value} onChange={onChange} required={required}/>
    </div>
)

export default TextAreaInput



// WEBPACK FOOTER //
// ./src/components/form/TextAreaInput.js